const cantSendYet = Symbol();
export default class ActionQueue {
    constructor() {
        this._awaitAddingQueue = [];
        this._queue = {};
        this._idPool = {};
        this._backId = [];
        this.add = this.add.bind(this);
    }
    resolve(id, type) {
        const col = this._backId[type];
        if (typeof col === "undefined")
            return id;
        const tID = col[id];
        return typeof tID === "undefined" ? id : tID;
    }
    add(action, data, proc) {
        if (proc.debounce) {
            const qid = `${action}"/"${data.id}`;
            const item = this._queue[qid];
            if (item) {
                clearTimeout(item);
            }
            this._queue[qid] = setTimeout(() => {
                this.add(action, data, { ...proc, debounce: false });
            }, proc.debounce);
            return;
        }
        const ready = this.tryExec(action, data, proc);
        if (ready === null) {
            //can't send data yet
            this._awaitAddingQueue.push({ action, data, proc });
        }
        else {
            ready.then((res) => {
                if (res &&
                    res.id &&
                    res.id != data.id &&
                    this.isTempID(data.id)) {
                    this._idPool[data.id] = res.id;
                    if (proc.kind) {
                        let t = this._backId[proc.kind];
                        if (!t)
                            t = this._backId[proc.kind] = {};
                        t[res.id] = data.id;
                    }
                    this.execQueue();
                }
            });
        }
    }
    tryExec(action, data, proc) {
        const ready = this.exec(action, data, proc);
        if (ready === null) {
            this._awaitAddingQueue.push({ action, data, proc });
        }
        return ready;
    }
    exec(action, data, proc) {
        const correctData = this.correctID(data, proc.ignoreID ? data.id : null);
        if (correctData === cantSendYet) {
            return null;
        }
        return proc.handler(correctData, action, data);
    }
    isTempID(v) {
        // regex format: "temp://1234567890123"
        return typeof v == "string" && /temp:\/\/\d{13}$/.test(v);
    }
    correctID(obj, ignore) {
        let copy = null;
        for (const key in obj) {
            const test = obj[key];
            if (typeof test === "object") {
                const after = this.correctID(test, ignore);
                if (after !== test) {
                    if (after === cantSendYet) {
                        return cantSendYet;
                    }
                    if (copy === null) {
                        copy = { ...obj };
                    }
                    copy[key] = after;
                }
            }
            else if (test !== ignore && this.isTempID(test)) {
                const hasRealID = this._idPool[test];
                if (!hasRealID) {
                    return cantSendYet;
                }
                if (copy === null) {
                    copy = { ...obj };
                }
                copy[key] = hasRealID;
            }
        }
        return copy || obj;
    }
    execQueue() {
        this._awaitAddingQueue = this._awaitAddingQueue
            .map(a => {
            return this.tryExec(a.action, a.data, a.proc) ? null : a;
        })
            .filter(a => a !== null);
    }
}
//# sourceMappingURL=ActionQueue.js.map